import ForgotPasswordForm from './ForgotPasswordForm';
import PasswordSentContent from './PasswordSentContent';
import PasswordIdentificationContent from './PasswordIdentificationContent';

function ForgotPasswordContent() {
  return (
    <>
      <ForgotPasswordForm />
      <PasswordSentContent />
      <PasswordIdentificationContent />
    </>
  );
}
export default ForgotPasswordContent;
